export default [
  {
    docType: "organization",
    name: "openfoodfacts-contributors",
    createdAt: "2015-06-14 11:31:12Z",
    reputation: 154,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/openfoodfacts-contributors.png",
    publicEmail: null,
    bio: null,
    orgName: "Open Food Facts",
    orgType: "NON_GOVERNMENT_NOT_FOR_PROFIT",
    url: "https://world.openfoodfacts.org/",
    country: "FR",
    address: "21 rue des Iles, 94100 Saint-Maur des Fossés, France"
  },
  {
    docType: "person",
    name: "odoc",
    createdAt: "2017-02-21 12:40:22Z",
    reputation: 12,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/odoc.png",
    publicEmail: null,
    bio: null,
    realName: null,
    url: null,
    location: null
  },
  {
    docType: "person",
    name: "zecourlis",
    createdAt: "2018-12-23 21:54:39Z",
    reputation: 2,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/zecourlis.png",
    publicEmail: null,
    bio: null,
    realName: null,
    url: null,
    location: null
  },
  {
    docType: "person",
    name: "user8402819102",
    createdAt: "2016-03-19 19:03:56Z",
    reputation: 2,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/user8402819102.png",
    publicEmail: null,
    bio: null,
    realName: null,
    url: null,
    location: null
  },
  {
    docType: "organization",
    name: "planetsavers",
    createdAt: "2019-11-21 11:31:12Z",
    reputation: 56,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/planetsavers.png",
    publicEmail: null,
    bio: null,
    orgName: "Planet Savers",
    orgType: "NON_GOVERNMENT_NOT_FOR_PROFIT",
    url: "https://planetsavers.co.uk/",
    country: "UK",
    address: "London"
  },
  {
    docType: "person",
    name: "NathSmith",
    createdAt: "2016-03-19 19:03:56Z",
    reputation: 2,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/NathSmith.png",
    publicEmail: null,
    bio: null,
    realName: "Nathalie Smith",
    url: null,
    location: null
  },
  {
    docType: "person",
    name: "mr-organic",
    createdAt: "2020-02-10 12:34:56Z",
    reputation: 5,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/mr-organic.png",
    publicEmail: null,
    bio: null,
    realName: null,
    url: null,
    location: null
  },
  {
    docType: "person",
    name: "sophie42",
    createdAt: "2018-11-26 14:51:18Z",
    reputation: 3,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/sophie42.png",
    publicEmail: null,
    bio: null,
    realName: null,
    url: null,
    location: null
  },
  {
    docType: "person",
    name: "new_user_2018-11-11",
    createdAt: "2018-11-11 11:11:11Z",
    reputation: 11,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/new_user_2018-11-11.png",
    publicEmail: null,
    bio: null,
    realName: null,
    url: null,
    location: null
  },
  {
    docType: "person",
    name: "blue_sky",
    createdAt: "2017-04-28 12:11:23Z",
    reputation: 9,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/blue_sky.png",
    publicEmail: null,
    bio: null,
    realName: null,
    url: null,
    location: null
  },
  {
    docType: "person",
    name: "sunshine32",
    createdAt: "2019-07-12 21:52:59Z",
    reputation: 3,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/sunshine32.png",
    publicEmail: null,
    bio: null,
    realName: null,
    url: null,
    location: null
  },
  {
    docType: "person",
    name: "justme",
    createdAt: "2020-05-11 23:47:33Z",
    reputation: 0,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/justme.png",
    publicEmail: null,
    bio: null,
    realName: null,
    url: null,
    location: null
  },
  {
    docType: "person",
    name: "ElisabethKent2015",
    createdAt: "2015-12-30 22:21:51Z",
    reputation: 34,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/ElisabethKent2015.png",
    publicEmail: null,
    bio: null,
    realName: null,
    url: null,
    location: "UK"
  },
  {
    docType: "person",
    name: "iron_butterfly",
    createdAt: "2018-11-12 23:14:24Z",
    reputation: 2,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/iron_butterfly.png",
    publicEmail: null,
    bio: null,
    realName: null,
    url: null,
    location: null
  },
  {
    docType: "person",
    name: "T.S.Newman",
    createdAt: "2019-06-04 01:23:19Z",
    reputation: 22,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/T.S.Newman.png",
    publicEmail: null,
    bio: null,
    realName: null,
    url: null,
    location: null
  },
  {
    docType: "person",
    name: "chocolatefan",
    createdAt: "2020-04-04 04:21:46Z",
    reputation: 1,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/chocolatefan.png",
    publicEmail: null,
    bio: null,
    realName: null,
    url: null,
    location: null
  },
  {
    docType: "person",
    name: "londonveganista",
    createdAt: "2020-04-22 17:33:41Z",
    reputation: 10,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/londonveganista.png",
    publicEmail: null,
    bio: null,
    realName: null,
    url: null,
    location: null
  },
  {
    docType: "person",
    name: "sarah32",
    createdAt: "2020-01-02 00:08:06Z",
    reputation: 1,
    lastCommentAt: null,
    lastCommentDeletedAt: null,
    avatarUrl: "/mockup/img/avatars/sarah32.png",
    publicEmail: null,
    bio: null,
    realName: null,
    url: null,
    location: null
  }
];
